import { useEffect } from "react";

const LOGO_WHITE_GOLD = "/praxis-logo-white.png";

export default function LandingDark() {
  useEffect(() => {
    document.title = "Praxis Sigma";
    const meta = document.querySelector('meta[name="theme-color"]');
    if (meta) meta.setAttribute("content", "#1C2B4A");
    const desc = document.querySelector('meta[name="description"]');
    if (desc)
      desc.setAttribute(
        "content",
        "Praxis Sigma LLC — private crypto futures joint ventures. By invitation only.",
      );
  }, []);

  return (
    <main
      data-testid="landing-page"
      className="ps-dark min-h-screen w-full flex flex-col"
      style={{ backgroundColor: "#1C2B4A" }}
    >
      {/* CLIENT LOGIN — discreet top-right */}
      <a
        data-testid="login-link"
        href={process.env.REACT_APP_PORTAL_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="ps-login"
        style={{ color: "#B8952A" }}
      >
        Login
      </a>

      {/* HERO */}
      <section
        data-testid="hero-section"
        className="w-full flex items-center justify-center px-6"
        style={{ paddingTop: "14vh", paddingBottom: "12vh" }}
      >
        <img
          data-testid="hero-logo"
          src={LOGO_WHITE_GOLD}
          alt="Praxis Sigma"
          className="ps-logo"
        />
      </section>

      {/* GOLD RULE */}
      <div className="w-full flex justify-center" data-testid="gold-divider">
        <span
          aria-hidden="true"
          style={{
            display: "block",
            height: "1px",
            width: "min(420px, 60%)",
            backgroundColor: "#B8952A",
          }}
        />
      </div>

      {/* POSITIONING STATEMENT */}
      <section
        data-testid="positioning-section"
        className="w-full flex flex-col items-center px-6"
        style={{ paddingTop: "10vh", paddingBottom: "10vh" }}
      >
        <p
          data-testid="positioning-statement"
          className="ps-statement text-center"
          style={{ color: "#F5F1E6" }}
        >
          We structure and manage private crypto futures joint ventures for a
          limited number of individually qualified capital partners. Engagements
          are conducted exclusively by private invitation.
        </p>
        <p
          data-testid="invitation-line"
          className="ps-invitation text-center"
          style={{ color: "#B8952A", marginTop: "2.25rem" }}
        >
          We do not accept unsolicited inquiries.
        </p>
      </section>

      {/* CONTACT */}
      <section
        data-testid="contact-section"
        className="w-full flex justify-center px-6"
        style={{ paddingBottom: "14vh" }}
      >
        <a
          data-testid="contact-email"
          href="mailto:legal@praxissigma.com"
          className="ps-contact"
          style={{ color: "#F5F1E6" }}
        >
          legal@praxissigma.com
        </a>
      </section>

      {/* FOOTER */}
      <footer
        data-testid="legal-footer"
        className="w-full mt-auto px-6"
        style={{
          paddingTop: "3rem",
          paddingBottom: "3rem",
          borderTop: "1px solid rgba(184, 149, 42, 0.25)",
        }}
      >
        <p
          className="ps-footer text-center mx-auto"
          style={{
            color: "rgba(245, 241, 230, 0.55)",
            maxWidth: "780px",
          }}
        >
          Praxis Sigma LLC is a private Wyoming limited liability company. This
          website does not constitute an offer to sell, a solicitation of an
          offer to buy, or a recommendation of any security, investment, or
          trading strategy. Engagements are conducted exclusively by referral
          and mutual introduction. Not intended for public distribution. © 2026
          Praxis Sigma LLC
        </p>
      </footer>
    </main>
  );
}
